export class DataCatalogPipelineResolvedGroupKeyInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "part",
            "baseName": "part",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineResolvedGroupKeyInner.attributeTypeMap;
    }
    constructor() {
    }
}
